import React from 'react';
import utils from 'utils';
import CommonButton from 'components/Buttons/CommonButton';
import { useDispatch, useSelector } from 'react-redux';
import selectors from 'state/selectors';
import services from 'services';
import { OriginalRow } from 'components/Table';
import actions from 'state/actions';
import { GetNopoVendorResponse } from 'models/response';
import { actionType } from 'utils/constants';

const DeleteTemplate = () => {
  const t = utils.intl.useTranslator();

  const selectedRow = useSelector(selectors.configurator.getSelectedAP2row);
  const templateList = useSelector(selectors.configurator.getTemplateAP2List);
  const isEdit = useSelector(selectors.configurator.getIsEditAP2Template);
  const { row: selectedNOPORow } = useSelector(selectors.modal.getModalProps);
  const rows = useSelector(selectors.configurator.getNOPOLeftTableRows);
  const editRowID = useSelector(selectors.configurator.getEditedRowAP2ID);

  const dispatch = useDispatch();

  const deleteRow = async () => {
    try {
      if (selectedRow?.idAp2Template) {
        await services.deleteAP2Template(selectedRow.idAp2Template.toString());
        const newRows: OriginalRow[] = templateList.filter((row) => row.idAp2Template !== selectedRow.idAp2Template);
        // update ap2template column in main table
        if (newRows.length === 0) {
          const selectedNopoRow = selectedNOPORow as GetNopoVendorResponse;
          const currentRows = rows as GetNopoVendorResponse[];
          const index = currentRows.findIndex((row) => row.id === selectedNopoRow.id);
          currentRows[index] = { ...currentRows[index], ap2Template: false };
          dispatch(actions.configurator.setNoPoLeftTableRows(currentRows as GetNopoVendorResponse[]));
        }
        dispatch(actions.configurator.setTemplateAP2List(newRows));
        dispatch(actions.configurator.setSelectedAP2row(null));
        utils.app.notify('success', t('ap2template-deleted'));
        return;
      }
      throw new Error('No template selected');
    } catch (error) {
      utils.app.notify('fail', error as Error);
    }
  };

  return (
    <CommonButton
      id="delete-template"
      action={deleteRow}
      disabled={
        isEdit ||
        editRowID !== null ||
        selectedRow === null ||
        !utils.user.isActionByCompanyActive(actionType.DELETE_AP2_TEMPLATE, selectedNOPORow.companyName)
      }
      scope="tertiary"
      value={t('delete')}
      customIcon="trash"
    />
  );
};
export default DeleteTemplate;
